<div class="wrapper">
    <img src="../../../assets/belairtrip_assets/svg_icon/sessionTimeOut.svg" alt="Session Expired" class="img-fluid">
    <h3>Your Session has Expired!</h3>
    <p>Please continue to book.</p>
    <button (click)="closeDialog()">Continue Search</button>
</div>